export const ALL_PRODUCTS_LABEL = "All Products";
